import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { getStorage, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { signInWithEmailAndPassword, getAuth } from "firebase/auth";
import { Link } from "react-router-dom";
import Advertisement from "../components/Advertisement";

const Admin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [users, setUsers] = useState([]);
    const [listings, setListings] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [activeTab, setActiveTab] = useState("users");
    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationTitle, setNotificationTitle] = useState("");
    const [image, setImage] = useState(null);
    const storage = getStorage();
    useEffect(() => {
        const checkAdmin = async () => {
            try {
                const adminQuery = query(collection(db, "admins"), where("email", "==", email));
                const adminSnapshot = await getDocs(adminQuery);
                if (!adminSnapshot.empty) {
                    setIsAdmin(true);
                }
            } catch (error) {
                console.error("Error checking admin:", error);
            }
        };

        const fetchUsers = async () => {
            try {
                const usersCollection = collection(db, "users");
                const usersSnapshot = await getDocs(usersCollection);
                const usersData = usersSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setUsers(usersData);
            } catch (error) {
                console.error("Error fetching users:", error);
                toast.error("Error fetching users!");
            }
        };

        const fetchListings = async () => {
            try {
                const listingsCollection = collection(db, "listings");
                const listingsSnapshot = await getDocs(listingsCollection);
                const listingsData = listingsSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setListings(listingsData);
            } catch (error) {
                console.error("Error fetching listings:", error);
                toast.error("Error fetching listings!");
            }
        };

        checkAdmin();
        fetchUsers();
        fetchListings();
    }, [email]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const adminQuery = query(collection(db, "admins"), where("email", "==", email));
            const adminSnapshot = await getDocs(adminQuery);
            if (adminSnapshot.empty) {
                await addDoc(collection(db, "admins"), {
                    email,
                    password,
                });
                toast.success("Admin account created successfully!");
            } else {
                await signInWithEmailAndPassword(getAuth(), email, password);
                toast.success("Logged in successfully!");
                setIsAdmin(true);
            }
        } catch (error) {
            console.error("Login error:", error);
            toast.error("Error logging in!");
        }
    };

    const deleteItem = async (collectionName, id) => {
        try {
            await db.collection(collectionName).doc(id).delete();
            if (collectionName === "users") {
                setUsers((prevUsers) => prevUsers.filter((user) => user.id !== id));
            } else if (collectionName === "listings") {
                setListings((prevListings) => prevListings.filter((listing) => listing.id !== id));
            }
            toast.success("Item deleted successfully!");
        } catch (error) {
            console.error("Error deleting item:", error);
            toast.error("Error deleting item!");
        }
    };

    const handleNotificationSubmit = async (e) => {
        e.preventDefault();

        try {
            let imageUrl = "";
            if (image) {
                const storageRef = storage.ref(`notifications/${image.name}`);
                await uploadBytesResumable(storageRef, image);
                imageUrl = await getDownloadURL(storageRef);
            }

            const docRef = await addDoc(collection(db, 'notifications'), {
                title: notificationTitle,
                message: notificationMessage,
                imageUrl: imageUrl,
                timestamp: new Date(),
                read: false,
            });
            toast.success('Notification sent successfully!');
            setNotificationMessage('');
            setImage(null);
        } catch (error) {
            console.error('Error sending notification:', error);
            toast.error('Error sending notification!');
        }
    };


    return (
        <div className="admin-page">
            <h1 className="text-center font-bold text-4xl mb-5">Admin Page</h1>
            {/* Login form */}
            {!isAdmin && (
                <form onSubmit={handleLogin} className="max-w-[768px] mx-auto gap-5">
                    <div className="flex flex-col">
                        <label htmlFor="email" className="mb-1">Email:</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="border p-2 rounded"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="password" className="mb-1">Password:</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="border p-2 rounded"
                        />
                    </div>
                    <button type="submit" className="bg-[#202A54] text-white py-2 px-4 rounded">
                        Login
                    </button>
                </form>
            )}

            {/* Admin content */}
            {isAdmin && (
                <>
                    <div className="tab-buttons max-w-[768px] mx-auto gap-5 flex justify-center">
                        <button
                            onClick={() => setActiveTab("users")}
                            className={`py-2 px-5 text-white ${activeTab === "users" ? "bg-[#F6D200]" : "bg-[#202A54]"}`}
                        >
                            Users
                        </button>
                        <button
                            onClick={() => setActiveTab("listings")}
                            className={`py-2 px-5 text-white ${activeTab === "listings" ? "bg-[#F6D200]" : "bg-[#202A54]"}`}
                        >
                            Listings
                        </button>
                        <button
                            onClick={() => setActiveTab("notifications")}
                            className={`py-2 px-5 text-white ${activeTab === "notifications" ? "bg-[#F6D200]" : "bg-[#202A54]"}`}
                        >
                            Notifications
                        </button>
                        <button
                            onClick={() => setActiveTab("ads")}
                            className={`py-2 px-5 text-white ${activeTab === "ads" ? "bg-[#F6D200]" : "bg-[#202A54]"}`}
                        >
                            Advertisement
                        </button>
                    </div>

                     {/* Users overlay */}
                    {activeTab === "users" && (
                        <div className="overlay">
                            <h2 className="text-center font-semibold text-xl mb-5">Users</h2>
                            <ul className="flex flex-wrap max-w-[1200px] mx-auto gap-3 justify-center">
                                {users.map((user) => (
                                    <div key={user.id} className="flex justify-between items-center bg-[#202A54] text-white py-3 px-7 w-[350px]">
                                        <Link to={`/profile/${user.id}`} className="flex items-center">
                                            <img src={user.photoURL} alt={user.name} className="w-12 h-12 rounded-full mr-2" />
                                            <span>{user.name} - {user.email.slice(0, 10)}...</span>
                                        </Link>
                                        <button onClick={() => deleteItem('users', user.id)} className="bg-[#F6D200] py-1 px-3">Delete</button>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Listings overlay */}
                    {activeTab === "listings" && (
                        <div className="overlay">
                            <h2 className="text-center font-semibold text-xl mb-5">Listings</h2>
                            <ul className="flex flex-wrap max-w-[1200px] justify-center mx-auto gap-1">
                                {listings.map((listing) => (
                                    <li key={listing.id} className="flex justify-between items-center bg-[#202A54] text-white py-3 px-7 w-[250px]">
                                        <Link to={`/listing/${listing.id}`} className="text-white">
                                            {listing.name.slice(0, 10)}...
                                        </Link>
                                        <button onClick={() => deleteItem('listings', listing.id)} className="bg-[#F6D200] py-1 px-3">Delete</button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Notifications overlay */}
                    {activeTab === "notifications" && (
                        <div className="overlay">
                            <h2 className="text-center font-semibold text-xl mb-5">Send Notification</h2>
                            <form onSubmit={handleNotificationSubmit} className="flex flex-col max-w-[768px] mx-auto gap-5">
                                <input type="text" 
                                    value={notificationTitle}
                                    onChange={(e) => setNotificationTitle(e.target.value)}
                                    placeholder="Enter notification Title..."
                                    className="border p-2 rounded"
                                    required
                                />
                                <textarea
                                    value={notificationMessage}
                                    onChange={(e) => setNotificationMessage(e.target.value)}
                                    placeholder="Enter notification message..."
                                    className="border p-2 rounded"
                                    required
                                ></textarea>
                                <input
                                    type="file"
                                    onChange={(e) => setImage(e.target.files[0])}
                                    className="border p-2 rounded"
                                />
                                <button type="submit" className="bg-[#202A54] text-white py-2 px-4 rounded">
                                    Send Notification
                                </button>
                            </form>
                        </div>
                    )}
                     {/* Advertisement overlay */}
                     {activeTab === "ads" && (
                        <div className="overlay">
                            <h2 className="text-center font-semibold text-xl mb-5">Upload Advertisement</h2>
                            <Advertisement />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Admin;
